import { Button, DiamondAnimation, Drawer, webApp } from '@shared'
import { useOverlayActions, useUser } from '@store'

import styles from './ChannelJoinDrawer.module.scss'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'

const CHANNEL_JOIN_CURRENCY = '$NOT'

export const ChannelJoinDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false)
  const [channelUrl, setChannelUrl] = useState('')
  const [amount, setAmount] = useState(0)
  const { checkChannelSubscription, getSubscriptionStatus } = useUser().actions
  const { t } = useTranslation()
  const { setOverlayQueue } = useOverlayActions()

  useEffect(()=> {
    if (localStorage.getItem('glance-channel-subscribed')) return;
    getSubscriptionStatus().then(res => {
      if (!res) return;
      if (res.redeemed) return;
      setAmount(res.score_per_use)
      setChannelUrl(res.channel_link);
      setIsOpen(true);
    })
  },[])

  const handleJoin = () => {
    webApp?.openTelegramLink(channelUrl);
  }

  const handleCheck = async () => {
    setIsLoading(true);
    const res = await checkChannelSubscription();
    if (!res || !res.subscribed) {
      setOverlayQueue([{
        type: 'error',
        payload: {
          description: 'channelJoinDrawer.error.description',
        },
      }])
    }
    if (res?.subscribed) {
      localStorage.setItem('glance-channel-subscribed', 'true');
      setOverlayQueue([{
          type: 'currencyReward',
          payload: {
            description: '',
            amount: res?.score,
          },
      }])
      setIsOpen(false)
    }
    setIsLoading(false);
    
  }

  return (
    <Drawer isOpen={isOpen} onClose={() => { setIsOpen(false)}}>
      <div className={styles.root}>
        <p className={styles.subtitle}>{t('channelJoinDrawer.title')}</p>
        <div className={styles.amountBlock}>
          <svg viewBox="0 0 199 183" fill="none" className={styles.diamond}>
            <DiamondAnimation optimized />
          </svg>
          <span className={styles.amount}>{amount}</span>
          <span className={styles.currency}>{CHANNEL_JOIN_CURRENCY}</span>
        </div>
        <div className={styles.buttons}>
          <Button onClick={handleJoin} icon="comet">{t('channelJoinDrawer.join')}</Button>
          <Button onClick={handleCheck} isLoading={isLoading} icon="check">{t('channelJoinDrawer.check')}</Button>
        </div>
      </div>
    </Drawer>
  )
}
